import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.996 1.25c1.05 0 1.876.793 2.403 1.862l1.763 3.553c.053.11.18.265.37.407s.377.22.5.24l3.189.534c1.152.194 2.118.758 2.431 1.742.313.982-.146 2.004-.974 2.834h-.001l-2.478 2.499a1.3 1.3 0 0 0-.277.528 1.3 1.3 0 0 0-.044.604v.002l.71 3.09c.294 1.287.196 2.562-.71 3.23-.911.668-2.155.372-3.286-.301l-2.99-1.785c-.125-.075-.34-.136-.6-.136s-.48.06-.613.138l-.002.001-2.984 1.781c-1.129.676-2.371.967-3.282.297-.907-.667-1.009-1.94-.714-3.225l.709-3.09v-.002a1.3 1.3 0 0 0-.043-.604 1.3 1.3 0 0 0-.277-.528l-2.48-2.5c-.823-.83-1.28-1.85-.97-2.832.312-.984 1.275-1.55 2.428-1.743l3.187-.534h.001c.117-.02.3-.097.49-.24.19-.141.318-.297.371-.407l.003-.005 1.76-3.549V3.11c.533-1.069 1.362-1.86 2.41-1.86"
    }, null, -1)
  ])))
}
export default { render: render }